import React from "react"
import { Row, Col } from "antd"
import { Customer } from "types/entity"
import { PROFILE_PAGE, VERIFY_PAGE } from "core/constants"
import { cdn } from "core/cdn"
import styles from "./Header.module.scss"
import { useNavigate, useLocation } from "react-router"
import FlagButton from "containers/Language/LanguageButton"
import Support from "components/Support"
import { getCurrentPatient } from "containers/Survey/services/selector"
import { getCall } from "containers/Call/services/selectors"
import { useDispatch, useSelector } from "react-redux"
import { languages } from "locales/languages"
import actions from "containers/Survey/services/actions"
import { ActionWithoutPayload } from "types/redux"


const Header: React.FC<{ patient?: Customer, showLanguageButton?: boolean }> = ({ patient, showLanguageButton }): JSX.Element => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const currentPatient = useSelector(getCurrentPatient)
  const currentCall = useSelector(getCall)
  const doNotdisplayUserProfile = [VERIFY_PAGE, PROFILE_PAGE].includes(
    location.pathname
  )

  const demoVersion = window.location.hostname === 'pharmacie.medadom-demo.com';
  return (
    <Row>
      <Col span={10}></Col>
      <Col span={4} style={{ textAlign: "center" }}>
        {patient?.is_verified && !doNotdisplayUserProfile && (
          <span
            onClick={() => {
              dispatch<ActionWithoutPayload>(actions.reset());
              navigate(PROFILE_PAGE)
            }}
            className={styles.ProfileLink}
          >
            <img height="30px" src={cdn("/images/people_picto.svg")} alt="" />
            <span className={styles.Nowrap}>

              {currentCall?.customer ? `${currentCall.customer.firstname} ${currentCall.customer.lastname}`
                : (currentPatient
                  ? `${currentPatient.firstname} ${currentPatient.lastname}`
                  : `${patient.firstname} ${patient.lastname}`)}
            </span>
          </span>
        )}
        {
        (!patient?.is_verified || doNotdisplayUserProfile) && demoVersion && (
          <span className={styles.demoLogo}>
            {languages.demoVersion}
          </span>
        )}
      </Col>
      {
        patient?.is_verified && !doNotdisplayUserProfile && demoVersion && (
          <>
            <Col span={1}></Col>
            <Col span={5}>
              <span className={styles.demoLogo}>
                  {languages.demoVersion}
              </span>
            </Col>
            <Col span={showLanguageButton ? 2 : 3}></Col>
          </>
        )
      }
      {(((!patient?.is_verified || doNotdisplayUserProfile) && demoVersion) || !demoVersion) && <Col span={showLanguageButton ? 8 : 9}></Col>}
      <Col span={1} style={{ textAlign: "right", paddingRight: "5px" }}>
        <Support />
      </Col>
      {showLanguageButton && <Col span={1} style={{ textAlign: "right" }}>
        <FlagButton />
      </Col>
      }
    </Row>
  )
}

export default Header
